import { Typography } from '@musinsa/mds';
import type { FC } from 'react';

interface NoticeBannerProps {
  label: string;
  labelColor?: string;
  text: string;
  textColor?: string;
  bgColor?: 'gray' | 'white';
  left?: React.ReactNode;
  right?: React.ReactNode;
  containerStyle?: React.CSSProperties;
  onClick?: () => void;
}

const NoticeBanner: FC<NoticeBannerProps> = ({
  bgColor,
  containerStyle,
  left,
  right,
  label,
  labelColor = '#245EFF',
  text,
  textColor = '#000',
  onClick,
}) => {
  return (
    <div
      className={`${bgColor === 'gray' ? 'bg-gray-100' : 'bg-white'} p-3`}
      style={{
        borderRadius: '4px',
        ...containerStyle,
      }}
      onClick={onClick}
    >
      <div className="flex gap-2 items-center w-full">
        {left && <div>{left}</div>}
        <div className="flex gap-2 flex-1 items-center textoverflow-ellipsis overflow-hidden whitespace-nowrap">
          <Typography
            size="13"
            weight="semiBold"
            className="shrink-0"
            style={{ color: labelColor }}
          >
            {label}
          </Typography>
          <Typography
            size="13"
            weight="semiBold"
            className="inline-block whitespace-nowrap overflow-hidden"
            style={{ color: textColor, textOverflow: 'ellipsis' }}
          >
            {text}
          </Typography>
        </div>
        {right && <div>{right}</div>}
      </div>
    </div>
  );
};

export { NoticeBanner, type NoticeBannerProps };
